import { Box, Button, Divider, FormLabel, Grid, IconButton, Input, Modal, Stack, Switch, Typography } from "@mui/material";
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { ServicesEdit as useServices } from "./services";
import { useNavigate } from "react-router-dom";
import { useCallback, useState } from "react";
import InputCep from "../../../../../components/inputs/cepInput";

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  borderRadius: '12px',
  boxShadow: 24,
  p: 2,
};

export default function EditEvento() {

  const { cadastrarCelula, celula, changeCampusCelula } = useServices();

  const router = useNavigate();

  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
    router(-1);
  };

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography id="modal-modal-title" variant="h5" component="h2">
              Evento
            </Typography>
            <IconButton aria-label="fechar" size="medium" onClick={handleClose}>
              <CloseRoundedIcon fontSize="inherit" />
            </IconButton>
          </div>
          <Divider />
          <Grid display={'grid'} gap={'8px'} mt={1} gridTemplateColumns={{ lg: 'repeat(2, 1fr)' }}>

            <Grid item display={'grid'}>
              <InputCep
                onChange={(value) => changeCampusCelula('cep', value)}
                value={celula?.cep}
              />
            </Grid>

            <Grid item display={'grid'}>
              <FormLabel>Bairro</FormLabel>
              <Input
                onChange={(value) => changeCampusCelula('bairro', value?.target?.value)}
                value={celula?.bairro}
              />
            </Grid>

            <Grid item display={'grid'}>
              <FormLabel>Rua</FormLabel>
              <Input
                value={celula?.rua}
                onChange={(value) => changeCampusCelula('rua', value?.target?.value)}
              />
            </Grid>
            <Grid item display={'grid'}>
              <FormLabel>Whatsapp</FormLabel>
              <Input
                onChange={(value) => changeCampusCelula('whatsapp', value?.target?.value)}
                value={celula?.whatsapp}
              />
            </Grid>
            <Grid item display={'grid'}>
              <FormLabel>Ativo</FormLabel>
              <Switch
                onChange={() => changeCampusCelula('ativo', !celula?.ativo)}
                checked={celula?.ativo || false}
              />
            </Grid>
            <Grid item display={'grid'}>
              <FormLabel>Permite Inscrição</FormLabel>
              <Switch
                onChange={() => changeCampusCelula('inscricao', !celula?.inscricao)}
                checked={celula?.inscricao || false}
              />
            </Grid>

          </Grid>
          <Stack mt={2} direction={'row'} justifyContent={'space-between'}>
            <Button color="error" onClick={handleClose}>Cancelar</Button>
            <Button onClick={cadastrarCelula}>Criar</Button>
          </Stack>
        </Box>
      </Modal>
    </>
  )
}
